 <template>
     <div class="cardGeneral" ref="content">
        <div class="cardReportes">
            <vs-row class="mb-4"> 
                <vs-col w="12">
                    <h4 class="p-2">Mapa de carga académica </h4>
                </vs-col>
                <vs-col sm="12" lg="2">
                    <div class="imgAlumno">
                    <img :src="'/api/personas/' + personaId + '/avatar'" @error="setAltImg" alt="alumno">
                    </div>
                </vs-col>
                <vs-col sm="12" lg="10" class="p-2">
                    <vs-row>
                        <vs-col sm="12" lg="6">
                            <h5>{{info.nombre}}</h5>
                            <p class="mb-1">Matrícula: <span> <strong>{{info.matricula}}</strong></span></p>
                            <p class="mb-1">Grupo Administrativo (No. Lista): <span> <strong>{{info.grupo_administrativo}}</strong></span></p>
                            <!-- <p>Semestre: <span> <strong>P-2022-2</strong></span></p>
                            <p class="mb-0">Materias inscritas: <span> <strong>3</strong></span></p>
                            <p>Créditos inscritos: <span> <strong>15.92</strong></span></p> -->
                        </vs-col>
                        <vs-col sm="12" lg="6">
                            <form autocomplete="off">
                                <vs-select class="aqui" filter label-placeholder="Institución" :key="institucionId" v-model="institucion" v-if="listInstituciones.length" @input="onChangeInstitucion" :disabled="!listInstituciones.length" autocomplete="off">
                                    <template v-if="listInstituciones.length" autocomplete="off">
                                        <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                            <form autocomplete="off">
                                <vs-select class="mr-0 mt-2" filter label-placeholder="Ciclo Escolar" v-model="cicloEscolar"  :key="cicloId" :disabled="!listCiclos.length" >
                                    <template v-if="listCiclos.length">
                                        <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                            <form autocomplete="off">
                                <vs-select class="mr-0 mt-2" filter label-placeholder="Programa" v-model="programa"  :key="programaId" :disabled="!listPrograma.length" >
                                    <template v-if="listPrograma.length">
                                        <vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
            <monitor-inscripcion :materias="materias"></monitor-inscripcion>
        </div>
     </div>
</template>

 <script>
import catalogos from '../../../../api/requests/catalogos.js'
import MonitorInscripcion from './tabla-mapa-inscripcion.vue'
import cobranza from '../../../../api/requests/cobranza-persona'
import landing from '../../../../api/requests/landing'
export default {
    props: [
        'personaId'
    ],
    data(){
        return{
            institucion: '',
            listInstituciones:[],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            listCiclos: [],
            cicloId: (new Date()).getTime(),
            programaDefault: '',
            listPrograma: [],
            programa: '',
            programaDefault: '',
            programaId: (new Date()).getTime(),
            materias: [],
            info: []
        }
    },
    components:{
        MonitorInscripcion
    },
    created(){
        this.getInstitucioneDefault()
    },
    methods:{
        async getInstitucioneDefault () {
             let params = {
                "persona": this.personaId
            }
            const { data: response } = await catalogos.getInstitutosDefault(params) || {}
            const { opciones: info, default: val } = response || {}
            this.listInstituciones = info instanceof Object ?  Object.values(info) : []
            this.institucion = val
            this.institucionId = (new Date()).getTime()
            this.idInstitucion = btoa(this.institucion)
            this.onChangeInstitucion ()
        },
        onChangeInstitucion () {
            this.listCiclos = []
            this.cicloEscolar = ''
            this.listarCiclos()
        },
        async getCicloDefault() {
            let params = {
                "nivel_academico": this.nivel,
                "institucion_id": this.institucion,
                "persona_id": this.personaId
            }
            const { data: response } = await catalogos.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.listCiclos = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloId = (new Date()).getTime()

        },
        async listarCiclos () {
            if (this.institucion){
                try {
                    this.getCicloDefault()
                    this.getPrograma()
                } catch (error) {
                        
                }
            }else {
                this.listCiclos = []
            }
        },
        async getCicloDefault() {
            let params = {
                "nivel_academico": this.nivel,
                "institucion_id": this.institucion,
                "persona_id": this.personaId
            }
            const { data: response } = await catalogos.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.listCiclos = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloId = (new Date()).getTime()

        },
        async getProgramas () {
            this.programa = ''
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion: this.institucion,
                id: this.personaId,
                ciclo_escolar: this.cicloEscolar,
            }
            const { data: response } = await cobranza.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.listPrograma = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                }
            }
        },
        async getInfoAlumno () {
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion_id: this.institucion,
                id: this.personaId,
                ciclo_escolar_id: this.cicloEscolar,
                programa_id: this.programa
            }
            const { data: response } = await cobranza.getInfoPersona(params)
            this.info = response
            }
        },
        async getMapaInscripcion(){
            if(this.programa){
                const loading = this.$vs.loading({
                    target: this.$refs.content
                })
                try{
                    const params = {
                        persona_id: this.personaId,
                        ciclo_escolar_id: this.cicloEscolar,
                        institucion_id: this.institucion,
                        programa_id: this.programa
                    }
                    
                    const { data: response } = await landing.getMapaInscripcion(params)
                    this.materias = response
                    loading.close()
                }catch(error){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un problema',
                        text: 'Favor de contactar al administrador'
                    })
                }
            }
        },
        setAltImg(event) { 
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg" 
        },
    },
    watch:{
        institucion(){
            this.getMapaInscripcion()
        },
        cicloEscolar(){
            this.getProgramas()
            this.getMapaInscripcion()
        },
        programa(){
            this.getInfoAlumno()
            this.getMapaInscripcion()
        },
        personaId(){
            this.getInstitucioneDefault()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px 20px;
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
</style>